<template>
  <article class="CardDadosPessoais w-100s">
    <form @submit.prevent="validar">
      <main>
        <div class="modal" :class="{ 'headline': loading == true }" id="modalDadosUsuario" tabindex="-1" role="dialog"
          aria-labelledby="modalDadosUsuario" aria-hidden="true" data-bs-backdrop="static" ref="modal">

          <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">
                  <strong>Atualize seus dados </strong>
                </h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="row m-3" v-if="erro">
                <div class="col card my-2 badge-danger text-center p-3 text-uppercase mt-3">
                  {{ erro }}
                </div>
              </div>
              <div class="modal-body">
                <div class="">
                  <div class="row mb-3 g-3">
                    <div class="col-sm-6">
                      <label for="nome" class="form-label">Nome</label>
                      <input :class="{ error: errorForm == true && msn.nome }" class="form-control" type="text" id="nome"
                        placeholder="Nome" v-model="dadosConta.nome" required />
                    </div>
                    <div class="col-sm-6">
                      <label for="nome" class="form-label">Sobrenome</label>
                      <input :class="{ error: errorForm == true && msn.sobreNome }" class="form-control" type="text"
                        id="sobreNome" placeholder="sobreNome" v-model="dadosConta.sobreNome" required />
                    </div>
                    <div class="col-sm-6 mt-3">
                      <label for="celular" class="form-label">CPF</label>
                      <input :class="{ error: errorForm == true && msn.cpf }" class="form-control" type="text" id="cpf"
                        v-model="dadosConta.cpf" v-mask="['###.###.###-##']" placeholder="000.0000.000-00" required />
                    </div>
                    <div class="col-sm-6 mt-3" v-if="dadosConta.pessoa">
                      <label for="matricula" class="form-label">Matricula</label>
                      <input :class="{ error: errorForm == true && msn.matricula }" class="form-control" type="tel"
                        id="matricula" v-model="dadosConta.pessoa.registroAssociacao1" placeholder="" />
                    </div>
                    <div class="col-sm-6 mt-3">
                      <label for="celular" class="form-label">Celular</label>
                      <input :class="{ error: errorForm == true && msn.telefone }" class="form-control" type="tel"
                        id="celular" v-model="dadosConta.pessoa.telefone.telefone"
                        v-mask="['(##) ####-####', '(##) #####-####']" placeholder="(00) 00000-0000" required />
                    </div>
                    <div class="col-sm-6 mt-3">
                      <label for="email" class="form-label">E-mail</label>
                      <input :class="{ error: errorForm == true && msn.email }" class="form-control" type="email"
                        id="email" placeholder="seu@email.com" v-model="dadosConta.pessoa.email" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="submit" class="btn" style="background-color: var(--cor-principal)">
                  Atualizar
                </button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </form>
    <Loading v-if="loading"></Loading>

  </article>
</template>

<script>
// @ is an alias to /src
import { APIService } from "../APIService";
const apiService = new APIService();
import Loading from "@/components/Loading.vue"

export default {
  name: "UsuarioClubeBeneficioAtualizar",
  props: ["clubeBeneficio", "dadosConta"],
  components: { Loading },

  data() {
    return {
      loading: false,
      nome: "",
      sobreNome: "",
      cpf: "",
      registroAssociacao1: "",
      email: "",
      telefone: "",
      errorForm: false,
      msn: { nome: false, sobreNome: false, cpf: false, email: false, telefone: false, matricula: false },
      erro: ""
    };
  },
  beforeUpdate() {
    if (!this.dadosConta.cpf) {
      this.dadosConta.cpf = "";
    }
  },
  mounted() {
  },
  methods: {
    validar() {
      this.errorForm = false;
      let errorField = false;

      if (!this.dadosConta.nome) {
        errorField = true;
        this.msn.nome = true
      }

      if (!this.dadosConta.sobreNome) {
        errorField = true;
        this.msn.sobreNome = true
      }

      if (!this.dadosConta.cpf) {
        errorField = true;
        this.msn.cpf = true
      }

      if (!this.dadosConta.pessoa.email) {
        errorField = true;
        this.msn.email = true
      }

      if (!errorField) {
        this.errorForm = true;
        this.atualizarDadosAssinarPlano();
      } else {
        this.loading = false;
      }


    },
    atualizarDadosAssinarPlano() {
      this.fecharModal();
      
      var dados = {
        conta: { contaId: this.dadosConta.conta.contaId },
        pessoa: {
          id: this.dadosConta.pessoa.id,
          nome: this.dadosConta.pessoa.nome = this.dadosConta.nome + " " + this.dadosConta.sobreNome,
          cpf: this.dadosConta.cpf ? this.dadosConta.cpf : this.dadosConta.pessoa.cpf,
          registroAssociacao1: this.dadosConta.pessoa.registroAssociacao1,
          telefone: this.dadosConta.pessoa.telefone,
          email: this.dadosConta.pessoa.email
        }
      }
      
      this.loading = true;
      apiService
        .atualizarDadosClubeBeneficio(dados, this.clubeBeneficio.id)
        .then((res) => {
          this.loading = false;
          if (res.linkAuth) {
            window.open(res.linkAuth, "_blank");
            window.location.reload();
          } else {
            this.erro = "ERRO AO ACESSAR BENEFÍCIO"

            this.loading = false;
            this.abrirModal();
          }
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.title
          ) {
            this.erro = error.response.data.title;
          }

          this.loading = false;
          window.scrollTo(0, 0);
        });
    },
    abrirModal() {
      this.$refs.modal.classList.remove("fade");
      this.$refs.modal.classList.add("show");
      this.$refs.modal.style.display = "block";
      document.body.classList.add("modal-open");
    },
    fecharModal() {
      this.$refs.modal.classList.remove("show");
      this.$refs.modal.style.display = "none";
      document.body.classList.remove("modal-open");
      this.zerarOpacidadeBackdrop();
    },
    zerarOpacidadeBackdrop() {
      const backdrop = document.querySelector('.modal-backdrop.show');
      if (backdrop) {
        backdrop.style.opacity = 0;
      }
    }
  },
};
</script>
<style scoped lang="scss">
button {
  background: var(--cor-principal);
  color: var(--cor-texto);
}

.a-divider.a-divider-break {
  text-align: center;
  position: relative;
  top: 2px;
  padding-top: 1px;
  margin-bottom: 14px;
  line-height: 0;

  &:after {
    content: "";
    width: 100%;
    background-color: transparent;
    display: block;
    height: 1px;
    border-top: 1px solid var(--cor-secundaria);
    position: absolute;
    top: 50%;
    margin-top: -1px;
    z-index: 1;
  }

  h5 {
    line-height: 1;
    font-size: 12px;
    color: #767676;
    font-weight: 400;
    z-index: 2;
    position: relative;
    display: inline-block;
    background-color: #fff;
    padding: 0 8px 0 7px;
  }

  .modal-lg {
    max-width: 800px;
    max-height: 200px;
  }

  .error {
    border-color: red !important;
  }

  .headline {
    z-index: 0 !important;
  }
}
</style>
